











import {defineComponent, PropType} from "vue";

export default defineComponent({
    name: "BulletList",
    props: {
        noStyle: {
            type: Boolean,
            default: false
        },
        texts: {
            type: Array as PropType<string[]>,
            required: true
        }
    }
});
